module.exports = __webpack_public_path__ + "img/service2DE.bd8c3194.svg";